"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuantityCalculator = void 0;
var lodash_1 = require("lodash");
var productUtils_1 = require("../productOptions/productUtils");
function getRange(start, end) {
    return start <= end ? (0, lodash_1.range)(start, end) : [];
}
exports.QuantityCalculator = {
    defaultQuantitiesRange: (0, lodash_1.range)(1, 100000),
    getQuantitiesRange: function (product, userSelections, options) {
        if (userSelections === void 0) { userSelections = []; }
        return product.isManageProductItems
            ? exports.QuantityCalculator.getFromUserSelections(product, userSelections, options)
            : exports.QuantityCalculator.getFromProduct(product);
    },
    getVariantsRepresentation: function (product, userSelections, options) {
        if (options === void 0) { options = {}; }
        var _a = options.isRemoveModifiersSelectionIdsFromUserSelections, isRemoveModifiersSelectionIdsFromUserSelections = _a === void 0 ? false : _a;
        var res;
        if (product.isManageProductItems && product.productItems && !(0, lodash_1.includes)(userSelections, null)) {
            var selectionsIds_1 = isRemoveModifiersSelectionIdsFromUserSelections
                ? userSelections
                    .map(function (x) { return x.id; })
                    .filter(function (selectionId) { var _a; return (_a = (0, productUtils_1.getProductOptionsSelectionIdsWithoutModifiers)(product)) === null || _a === void 0 ? void 0 : _a.includes(selectionId); })
                : userSelections.map(function (x) { return x.id; });
            res = product.productItems.filter(function (item) { return (0, lodash_1.isEqual)(item.optionsSelections, selectionsIds_1); })[0];
        }
        return res;
    },
    getFromProduct: function (product) {
        var _a, _b;
        var isAvailableForPreOrder = product.inventory.availableForPreOrder;
        var isTrackingPreOrder = isAvailableForPreOrder && Number.isInteger((_a = product.inventory.preOrderInfoView) === null || _a === void 0 ? void 0 : _a.limit);
        if (isAvailableForPreOrder && !isTrackingPreOrder) {
            return exports.QuantityCalculator.defaultQuantitiesRange;
        }
        if (product.isTrackingInventory && isTrackingPreOrder) {
            return getRange(1, product.inventory.quantity + 1 + ((_b = product.inventory.preOrderInfoView) === null || _b === void 0 ? void 0 : _b.limit));
        }
        if (product.isTrackingInventory) {
            var quantity = product.inventory.quantity;
            return (0, lodash_1.range)(1, quantity >= 0 ? quantity + 1 : 1);
        }
        else if (product.inventory.status === 'out_of_stock') {
            return [];
        }
        return exports.QuantityCalculator.defaultQuantitiesRange;
    },
    getFromUserSelections: function (product, userSelections, options) {
        var _a, _b, _c;
        if (options === void 0) { options = {}; }
        var _d = options.fixNegativeInventoryForPreOrder, fixNegativeInventoryForPreOrder = _d === void 0 ? false : _d;
        var selectedVariance = exports.QuantityCalculator.getVariantsRepresentation(product, userSelections, options);
        var isAvailableForPreOrder = selectedVariance
            ? selectedVariance.availableForPreOrder
            : product.inventory.availableForPreOrder;
        var productPreOrderLimit = (_a = product.inventory.preOrderInfoView) === null || _a === void 0 ? void 0 : _a.limit;
        var variantPreOrderLimit = (_b = selectedVariance === null || selectedVariance === void 0 ? void 0 : selectedVariance.preOrderInfo) === null || _b === void 0 ? void 0 : _b.limit;
        var isTrackingPreOrder = isAvailableForPreOrder && (Number.isInteger(productPreOrderLimit) || Number.isInteger(variantPreOrderLimit));
        if (!selectedVariance) {
            return exports.QuantityCalculator.defaultQuantitiesRange;
        }
        if (isAvailableForPreOrder && !isTrackingPreOrder) {
            return exports.QuantityCalculator.defaultQuantitiesRange;
        }
        var isTrackingInventory = (_c = selectedVariance === null || selectedVariance === void 0 ? void 0 : selectedVariance.isTrackingInventory) !== null && _c !== void 0 ? _c : product.isTrackingInventory;
        if (isTrackingInventory) {
            var variantQuantity = selectedVariance.inventory.quantity;
            if (isTrackingPreOrder) {
                return getRange(1, variantQuantity + 1 + (productPreOrderLimit || variantPreOrderLimit));
            }
            else if (fixNegativeInventoryForPreOrder) {
                return (0, lodash_1.range)(1, variantQuantity >= 0 ? variantQuantity + 1 : 1);
            }
            else {
                return (0, lodash_1.range)(1, variantQuantity + 1);
            }
        }
        else if (selectedVariance.inventory.status === 'out_of_stock') {
            return [];
        }
        return exports.QuantityCalculator.defaultQuantitiesRange;
    },
};
//# sourceMappingURL=quantityCalculator.js.map